import { useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import BulkImport from './components/BulkImport';
import PageHeader from '../../../component/PageHeader';
import { Button, Form, Input } from 'antd';
import { AccommodationBreadrumbs } from '../../../config/BreadcrumbConfig';
import ListComponent from './components/ListComponent';
import useStore from '../../../store';
import AddComponent from './components/AddComponent';
import DeleteMerchantComponent from './components/DeleteMerchantComponent';

const Accommodation = observer(() => {
	const [accommodationAddModal, setaccommodationAddModal] = useState(false);
	const [accommodationEditModal, setaccommodationEditModal] = useState(false);
	const [accommodationDeleteModal, setaccommodationDeleteModal] =
		useState(false);
	const [accommodationImport, setAccommodationImport] = useState(false);
	const { ACCOMMODATION } = useStore();

	const addBulkImport = () => {
		setAccommodationImport(true);
	};
	const AddAccommodationModal = () => {
		setaccommodationAddModal('add');
	};
	const closeAccommodationImport = () => {
		setAccommodationImport(false);
	};
	const openEdit = () => {
		setaccommodationAddModal('edit');
		// setaccommodationEditModal(true);
	};
	const openDelete = (data) => {
		setaccommodationDeleteModal(data);
	};
	const closeAddModal = () => {
		setaccommodationAddModal(false);
	};

	const closeDeleteModal = () => {
		setaccommodationDeleteModal(false);
	};
	const onSearch = (text) => {
		if (text.length >= 3 || text.length === 0) {
			ACCOMMODATION.searchValue = text;
			ACCOMMODATION.setupGrid(ACCOMMODATION.agGrid);
		}
	};
	useEffect(() => {
		return () => {
			ACCOMMODATION.searchValue = '';
		};
	}, []);
	return (
		<div className="mainPageWrap">
			<PageHeader
				className="mainPageHeader"
				title={AccommodationBreadrumbs.title}
				extra={[
					<Form.Item help={'Enter 3 character to search'} key={1}>
						<Input
							placeholder="Search here"
							onChange={(e) => onSearch(e.target.value)}
						/>
					</Form.Item>,
					<Button
						key={2}
						type="primary"
						className="addBtn"
						onClick={AddAccommodationModal}
					>
						Add Accommodation
					</Button>,
					<Button key={3} type="primary" onClick={addBulkImport}>
						Bulk Accommodation Import
					</Button>,
				]}
			/>
			<ListComponent
				openEditModal={openEdit}
				openDeleteModal={openDelete}
			/>
			<AddComponent
				visible={accommodationAddModal}
				onClose={closeAddModal}
			/>
			<DeleteMerchantComponent
				visible={accommodationDeleteModal}
				onClose={closeDeleteModal}
			/>
			<BulkImport
				visible={accommodationImport}
				onClose={closeAccommodationImport}
			/>
		</div>
	);
});

export default Accommodation;
